import { view } from "../../../views/mapView/MapView";
import ImageryLayer from "@arcgis/core/layers/ImageryLayer";
import BasemapLayerList from "@arcgis/core/widgets/BasemapLayerList";
import BasemapGallery from "@arcgis/core/widgets/BasemapGallery";
import Portal from "@arcgis/core/portal/Portal";
import PortalBasemapsSource from "@arcgis/core/widgets/BasemapGallery/support/PortalBasemapsSource";


const SwipeVM =async (view,divElement) => {
    const [{ default : Swipe }] = await Promise.all([
        await import("@arcgis/core/widgets/Swipe")
    ]);

    let swipeWidget = await view.when(
        (view) => {
            // const eagle2021 = new ImageryLayer({
            //      url: "https://www.ocgis.com/arcpub/rest/services/Aerial_Imagery_Countywide/Eagle_Aerial_2021_OC_1FT_sid/ImageServer",
            //      listMode: "hide"
            // });
            //view.map.add(eagle2021)

            // let OcPortal = new Portal({
            //     url:"https://ocpw.maps.arcgis.com"
            // });

            // let source = new PortalBasemapsSource({
            //     portal: OcPortal,
            //     query: {
            //         title: "Custom Basemap Gallery",
            //         owner: "OCPublicWorks"
            //       }
            // });

            // const basegalWidget = new BasemapGallery({
            //     view: view,
            //     source: source
            // }) 
            
            // let basemapList = new BasemapLayerList({
            //     view: view,
            // })


            let Widget: any = new Swipe({
                //view: view,
                //container: divElement,
                leadingLayers: view.map.allLayers.filter((lyr)=>lyr.type!=='elevation' && lyr.type !== 'tile'), //remove elevation layer from basemap
                trailingLayers: [],//basegalWidget.source.basemaps,
                direction: "horizontal",
                position: 60,
                // disabled:true,
                // visible:false  
            });
            return Widget;
        },
        (e) => console.error("failed to load during view.when", e)
    );
    return swipeWidget; 
};

export default SwipeVM;

